import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Weddings from './components/Weddings';
import Catering from './components/Catering';
import Amenities from './components/Amenities';
import Gallery from './components/Gallery';
import WeddingJournal from './components/WeddingJournal';
import Contact from './components/Contact';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import { useHashScroll } from './hooks/useHashScroll';

function App() {
  useHashScroll();
  return (
    <div className="font-sans text-brand-charcoal bg-brand-ivory overflow-x-hidden selection:bg-brand-olive selection:text-white">
      <Navbar />
      <Hero />
      <Weddings />
      <Catering />
      <Amenities />
      <Gallery />
      <WeddingJournal />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;